<template>
    <div>
        <Modal v-if="isModalConfirm" @close="() => (isModalConfirm = false)" width="40%">
            <h1 class="modal-title">Peringatan</h1>
            <p>Apakah kamu yakin ingin menghapus data ini?</p>
            <div style="display: flex; justify-content: center; gap: 15px;">
                <button @click="isModalConfirm = false" class="btn-cancel">Tidak</button>
                <button @click="openDelete" class="btn-save">Ya</button>
            </div>
        </Modal>
        <div class="container-data-n">
        <div class="container-tabel">
            
            
            <table class="tabel borderless-table">
                <thead style="border: 2px solid black">
                    <tr>
                        <th class="table-head border-tabel" :style="{ width: '50px' }">No</th>
                        <th v-for="(header, index) in headers" :key="index" class="table-head border-tabel"
                            :style="{ width: header.width ? `${header.width}px` : 'auto' }">
                            {{ header.text }}
                        </th>
                        <th class="table-floting border-tabel" :style="`width: ${widthAction}px !important`">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(row, rowIndex) in rows" :key="rowIndex"
                        :style="{ backgroundColor: rowIndex % 2 === 1 ? '#f5f6f9' : 'transparent' }">
                        <td class="table-body tbody" :style="{ width: '50px' }">
                            {{ getRowNumber(rowIndex) }}
                        </td>

                        <td v-for="(header, colIndex) in headers" :key="colIndex" class="table-body tbody"
                            :style="{ 
                                width: header.width ? `${header.width}px` : 'auto',
                                wordBreak: 'break-word',
                                whiteSpace: 'normal'
                            }">
                            <template v-if="hasCustomRender(header.field)">
                                <div v-html="getCustomRender(header.field, row)"></div>
                            </template>
                            <template v-else>
                                <div class="cell-content">
                                    {{ row[header.field] }}
                                </div>
                            </template>
                        </td>
                        <td :style="`background-color: ${rowIndex % 2 === 1 ? '#f5f6f9' : ''}; width: ${widthAction}px !important`"
                            class="table-floting">
                            <div class="warp-btn-action">
                                <button class="btn-action" @click.prevent="onEdit(row.id)">
                                    UBAH
                                </button>
                                <button class="btn-action" @click.prevent="onView(row.id)">
                                    LIHat
                                </button>
                                <button class="btn-action" @click.prevent="deleteData(row.id)">
                                    HAPUS
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
        <NoDataAlert v-if="rows.length === 0" />
        <v-row justify="center" v-else>
            <v-col cols="12">
                <v-container class="max-width">
                    <v-pagination v-model="localCurrentPage" class="my-4" :length="totalPages"
                        @input="handlePageChange"></v-pagination>
                </v-container>
            </v-col>
        </v-row>

        <h5 v-if="rows.length > 0" style="font-weight: 400" class="text-jumlah">
            Menampilkan
            <span style="font-weight: 700">{{
                Math.floor((currentPage - 1) * perPage + rows.length)
                }}</span>
            dari
            <span style="font-weight: 700">{{ totalData }}</span>
        </h5>
    </div>
</template>

<script>
import Modal from './Modal.vue';
import NoDataAlert from './NoDataAlert.vue'; 

export default {
    components: {
        Modal,
        NoDataAlert 
    },
    props: {
        headers: {
            type: Array,
            required: true,
        },
        rows: {
            type: Array,
            required: true,
        },
        currentPage: {
            type: Number,
            required: false,
            default: 0,
        },
        totalPages: {
            type: Number,
            required: false,
            default: 0,
        },
        totalData: {
            type: Number,
            required: false,
            default: 0,
        },
        perPage: {
            type: Number,
            required: false,
            default: 0,
        },
        onEdit: {
            type: Function,
            required: false,
        },
        onView: {
            type: Function,
            required: false,
        },
        onDelete: {
            type: Function,
            required: false,
        },
        widthAction: {
            type: Number,
            default: 250
        },
        onPageChange: {
            type: Function,
            required: false,
        },
        customColumns: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localCurrentPage: this.currentPage,
            isModalConfirm: false,
            id: "",
        };
    },
    watch: {
        currentPage(newPage) {
            this.localCurrentPage = newPage;
        },
    },
    methods: {
        handlePageChange(page) {
            this.onPageChange(page);
        },
        openDelete() {
            this.isModalConfirm = false
            this.onDelete(this.id)
        },
        deleteData(id) {
            this.id = id
            this.isModalConfirm = true
        },
        hasCustomRender(field) {
            return this.customColumns.some((col) => col.field === field);
        },
        getCustomRender(field, row) {
            const column = this.customColumns.find((col) => col.field === field);
            return column ? column.render(row) : '';
        },
        getRowNumber(rowIndex) {
            return (this.currentPage - 1) * this.perPage + rowIndex + 1;
        },
    },
};
</script>

<style scoped>
/* Style yang sama seperti sebelumnya */
.tbody {
    margin: 0;
    font-weight: 400;
    border-collapse: collapse;
    font-size: 14px;
}

.borderless-table {
    table-layout: fixed;
    width: 100%;
}

.tbody-color-red {
    color: #b80f0a;
}

.tbody-color-gray {
    color: #7b7e8c;
}

.container-data-n {
    margin-top: 30px;
    padding: 15px 30px;
    background-color: white;
    border-radius: 16px;
}

.container-tabel {
    background-color: white;
    overflow-x: auto;
}

.tabel {
    position: relative;
    border: none;
    width: 100%;
    border-collapse: collapse;
}

.table-head {
    min-width: 200px;
    background-color: white;
    white-space: nowrap;
    width: auto;
    padding: 10px;
}

.border-tabel {
    border-top: 2px solid transparent;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
    border-bottom: 2px solid #e5e7e9;
}

.table-body {
    min-width: 200px;
    height: 141px;
    white-space: normal;
    width: auto;
    padding: 10px;
    text-align: center;
    word-break: break-word;
}

.table-floting {
    white-space: nowrap;
    text-align: center;
    position: sticky;
    right: 0;
    background-color: white;
}

.warp-btn-action {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.btn-action {
    background-color: white;
    width: 79px;
    height: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #575966;
    font-size: 14px;
    font-weight: 500;
    color: #2d46cf;
    border: 1px solid #acafbf;
}

.text-jumlah {
    font-size: 12px;
    font-weight: 400px;
}

.pegenation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px auto;
}

.pegenation-text {
    font-size: 14px;
    font-weight: 700;
    margin-left: 15px;
    margin-right: 15px;
}

.btn-cancel {
    border-radius: 10px;
    border: 1px solid #acafbf;
    padding: 10px 36px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #acafbf;
}

.btn-save {
    border-radius: 10px;
    background-color: #2d46cf;
    border: 1px solid #2d46cf;
    padding: 10px 36px;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
}

.cell-content {
    word-break: break-word;
    white-space: normal;
    padding: 5px;
}
</style>